export default __webpack_public_path__ + "static/wave-05636e8b20464c57c1b06a5cfff425f3.svg";